<template>
  <div id="historico-ocorrencia">
    <div class="anotacoes">
      <div class="container-anotacoes" v-if="anotacoes.length > 0">
        <div v-for="anotacao in anotacoes" :key="anotacao.id_ocorrencia_anotacoes"
             :class="{ 'anotacao': anotacao.arquivos && anotacao.arquivos.length > 0 }">
          <el-row class="anotacao-info" v-if="anotacao.arquivos && anotacao.arquivos.length > 0 && anotacao.tipo === 0">
            <el-col :span="16">
              <span>{{[anotacao.data_registro, 'x'] | moment('DD/MM/YYYY')}}</span>
              <span>{{[anotacao.data_registro, 'x'] | moment('HH:mm')}}</span>
              <span>{{anotacao.atendente}}</span>
            </el-col>
          </el-row>
          <div class="arquivos" v-if="anotacao.arquivos && anotacao.arquivos.length > 0 && anotacao.tipo === 0">
            <div class="arquivo" v-for="arquivo in anotacao.arquivos" :key="arquivo.key">
              <div class="file-name"><img class="img-prev" v-if="isImage(arquivo)" :src="arquivo.url"/><span v-if="!isImage(arquivo)"><i class="icon-prev el-icon-document"></i> </span><p>{{arquivo.nome}}</p></div>
              <div><span class="file-size">{{arquivo.size | sizeFilter}}</span> <el-button type="text" @click="onAbrir(arquivo.url)">ABRIR</el-button></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center empty-data">
        <h4>Nenhum Anexo</h4>
        <p>Nenhum anexo foi incluído nessa solicitação.</p>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AnexosOcorrencia',
  components: {
  },
  data () {
    return {
      anotacoes: []
    }
  },
  props: {
    idOcorrencia: {}
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao']),
    ...mapState('SetupApp', ['funcionalidade', 'apiOcorrenciaPublico'])
  },
  filters: {
    sizeFilter (value) {
      let formated = value
      let suffix = 'b'

      if (formated > 1024) {
        formated = (formated / 1024).toFixed(3)
        suffix = 'Kb'

        if (formated > 1024) {
          formated = (formated / 1024).toFixed(3)
          suffix = 'Mb'
        }

        if (formated > 1024) {
          formated = (formated / 1024).toFixed(3)
          suffix = 'Gb'
        }
      }

      return `${formated} ${suffix}`
    }
  },
  methods: {
    async init () {
      await this.getAnotacoes()
    },
    async getAnotacoes () {
      const response = await this.apiOcorrenciaPublico.carregarAnotacoes({
        loading: true,
        params: {
          'idOcorrencia': this.idOcorrencia,
          'idOperadora': this.aplicacao.idOperadora
        },
        notifyFailure: true,
        handlerErrorIgnore: false
      })
      this.anotacoes = response.data.filter(anotacao => anotacao.arquivos !== null && anotacao.arquivos !== undefined)
    },
    isImage (arquivo) {
      return arquivo.mimeType.includes('image')
    },
    onAbrir (url) {
      window.open(url, '_blank').focus()
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="less">
.anotacoes {
  box-sizing: border-box;
  overflow-y: auto;
  width: 100%;
  min-height: 400px;
  max-height: 1000px;

  .container-anotacoes{
    padding: 15px 40px 0 15px;
  }

  .anotacao {
    padding: 0 0 15px 15px;
    position: relative;

    &:after {
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background: #B8D5F9;
      position: absolute;
      left: -3px;
      top: 2px;
      content: '';
    }
    &:before {
      display: block;
      width: 2px;
      content: '';
      height: 100%;
      background: #B8D5F9;
      position: absolute;
      left: 0;
      top: 3px;
    }
    &:last-child {
      &:after {
        background: #1375EA;
      }
      &:before {
        display: none;
      }
    }
    .anotacao-info {
      font: 12px Arial;
      margin: 0 0 5px;
      color: #888888;

      span {
        display: inline-block;
        margin-right: 15px;
      }
    }
    .material-icons-outlined {
      font-size: 13px;
      vertical-align: bottom;
    }
    .anotacao-info-interno {
      font: 12px Arial;
      margin: 0 0 5px;
      color: #888888;

      span {
        display: inline-block;
        margin-right: 0 !important;
      }
    }
    .mensagem {
      padding: 10px 15px;
      border-radius: 6px;
      background: #F6F6F6;
      font: 14px Arial;
      color: #333333;
      word-break: break-all;
      white-space: pre-line;
      margin: 0;
    }
    .anotacao-interna{
      background: #FFF2AD !important;
      border: 1px dashed #C4B66F !important;
    }
    .arquivos {
      padding: 10px 15px;
      border-radius: 6px;
      background: #F6F6F6;

      p {
        white-space: pre-line;
        color: #333333;
        font: 14px Arial;
        margin: 0 0 10px;
      }
      .arquivo {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .file-name {
          display: flex;
          align-items: center;
          font: 11px Arial;
          color: #333333;

          .img-prev {
            width: 20px;
            margin-right: 10px;
            height: 20px;
          }
          .icon-prev {
            font-size: 20px;
            margin-right: 10px;
            line-height: 20px;
          }
          > p {
            margin: 0;
          }
        }
        .file-size {
          font: 11px Arial;
          color: #888888;
          margin-right: 15px;
        }
        .el-button {
          font: bold 11px Arial;
          margin: 0 15px 0 0;
        }
      }
    }
  }
}
.empty-data{
  padding-top:10%;

  .h4{
    color: #999999;
    font-size:16px;
  }
  .p{
    font-size:14px;
    color: #999999;
  }
}
</style>
